import React from "react";
import classes from "./ActionsContainer.scss";
import { EyeOutlined, DeleteOutlined } from "@toddle-edu/ds-icons";
import { Tick, CheckTickOff } from "SvgComponents";
import LinkWithTooltip from "UIComponents/LinkWithTooltip";
import I18nHOC from "UIComponents/I18nHOC";
import { colors } from "Constants";
import classNames from "classnames";
import { onEnterOrSpaceKeyDown } from "Utils";

const ActionIconsContainer = props => {
  const {
    styles,
    isSelected,
    showBlackOverlay,
    t,
    onCardClick,
    data,
    onClickView,
    children,
    showDeleteOption,
    onClickDelete,
    isNew,
  } = props;

  const handleSelect = () => {
    if (onCardClick) onCardClick({ id: data.id, type: data.itemType });
  };

  const handleView = e => {
    e.stopPropagation();
    if (onClickView) onClickView({ data, evidenceType: data.itemType });
  };

  const handleDelete = e => {
    e.stopPropagation();
    if (onClickDelete) onClickDelete({ data, isSelected });
  };

  const eyeIconClassList = classNames(classes.icon, {
    [classes.iconWithOverlay]: showBlackOverlay,
  });

  const unSelectIconClassList = classNames(classes.icon, {
    [classes.iconWithOverlay]: showBlackOverlay,
  });

  return (
    <div
      className={classes.container}
      tabIndex={onCardClick ? 0 : -1}
      onKeyDown={event => onEnterOrSpaceKeyDown(event, handleSelect)}
    >
      {children}
      {showBlackOverlay && (
        <div
          className={classes.overlayContainer}
          style={styles.overlayContainerStyle}
          onClick={handleSelect}
        />
      )}

      <div
        className={classes.iconsContainer}
        onClick={handleSelect}
        style={styles.iconsContainerStyle || {}}
      >
        <div className={classes.hoverOnlyIconsContainer}>
          <div
            className={eyeIconClassList}
            tabIndex={onClickView ? 0 : -1}
            onClick={handleView}
            onKeyDown={event => onEnterOrSpaceKeyDown(event, handleView, false)}
          >
            <LinkWithTooltip
              tooltip={t("common:view")}
              linkStyles={{ display: "flex" }}
            >
              <EyeOutlined
                size={"xxx-small"}
                variant={showBlackOverlay ? "on" : "subtle"}
              />
            </LinkWithTooltip>
          </div>
          {showDeleteOption && (
            <div
              className={classes.icon}
              tabIndex={onClickDelete ? 0 : -1}
              onClick={handleDelete}
              onKeyDown={event => onEnterOrSpaceKeyDown(event, handleDelete)}
            >
              <LinkWithTooltip tooltip={t("common:remove")}>
                <DeleteOutlined
                  variant={showBlackOverlay ? "on" : "subtle"}
                  size={"xxx-small"}
                />
              </LinkWithTooltip>
            </div>
          )}
        </div>

        <div
          tabIndex={0}
          className={isSelected ? classes.icon : unSelectIconClassList}
        >
          {isSelected ? (
            <Tick width={16} height={16} fill={colors.blue400} />
          ) : (
            <CheckTickOff width={16} height={16} />
          )}
        </div>
      </div>
      {isNew ? <div className={classes.indicator} /> : null}
    </div>
  );
};

ActionIconsContainer.defaultProps = {
  showBlackOverlay: false,
  showDeleteOption: false,
};

export default I18nHOC({ resource: ["common"] })(ActionIconsContainer);
